import React from 'react';

import SvgIcon from '../SvgIcon';
import type { IconProps } from '../types';

const ActionArrowIcon: React.FC<IconProps> = ({ className, size, disabled, direction }) => (
  <SvgIcon
    viewBox="0 0 20 20"
    className={className}
    size={size}
    disabled={disabled}
    strokeWidth={1.5}
    direction={direction}
    fill="currentColor"
    stroke="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.15962 6.84819c-.24408-.24408-.24408-.6398 0-.88388l3.28128-3.28125c.244-.24408.6398-.24408.8839 0l3.2812 3.28125c.2441.24408.2441.6398 0 .88388-.2441.24408-.6398.24408-.8839 0l-2.8393-2.83931-2.8393 2.83931c-.24407.24408-.6398.24408-.88388 0Z"
      fill="currentColor"
      stroke="none"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8828 12.5c-.3452 0-.625-.2798-.625-.625v-8.75c0-.34518.2798-.625.625-.625s.625.27982.625.625v8.75c0 .3452-.2798.625-.625.625Z"
      fill="currentColor"
      stroke="none"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.74893 17.1339c-.23442-.2344-.36612-.5524-.36612-.8839v-4.375c0-.3452.27982-.625.625-.625s.625.2798.625.625v4.375H17.1328v-4.375c0-.3452.2798-.625.625-.625s.625.2798.625.625v4.375c0 .3315-.1317.6495-.3661.8839-.2344.2344-.5524.3661-.8839.3661H4.63281c-.33152 0-.64946-.1317-.88388-.3661Z"
      fill="currentColor"
      stroke="none"
    />
  </SvgIcon>
);

export default ActionArrowIcon;
